import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { Transit } from '@/types/core/transit/transit';
import { TRANSIT_STATUS_VARIANTS } from './transit-status-config';

export function TransitStatusBadge({ status }: { status: Transit['status'] }) {
  const { t } = useTranslation('transits');

  return (
    <Badge
      className='rounded-full border px-4 py-1 font-medium text-xs uppercase tracking-wide'
      variant={TRANSIT_STATUS_VARIANTS[status.id] ?? 'gray'}
    >
      {t(`status.${status.id}`, {
        defaultValue: status.name ?? t('unknownStatus'),
      })}
    </Badge>
  );
}
